module.exports = __webpack_public_path__ + "img/case-logo-27.28c9ef1f.png";